import axios from 'axios';
import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { getCategoriesDomains, getBrandsCategories } from '../../utils/api.js';
import { makeMenuLink } from '../ShoppingCartUtils/Helpers.js';
import { MDBBtn, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu } from 'mdbreact';
import NavigationListData from './NavigationLinksData.json';
import SideNavigation from '../SideNavigation/SideNavigation.js';
import SkipLinksBlock from '../SkipLinks/SkipLinksBlock.js';
import Spinner from '../Spinner/Spinner.js';
import { $qs } from '../../helpers/misc-javascript-helpers.js';


/**
 * Navigation class extends the the Component class. This component is a Navigation system
 * that incorporates various methods which control and respond to user interactions.
 */
class NavigationV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sideMenu: '',
            overlay: '',
            isMobileOpen: '',
            mobileDropDownStyle: '0px',
            totalCartItems: '',
            isLoading: true,
            pathName: '',
            searchFieldValue: '',
            skipLinksOn: false,
            categoriesData: {},
            activeLogo: false

        };
        this.openSideBar = this.openSideBar.bind(this);
        this.closeSideBar = this.closeSideBar.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCartCount = this.handleCartCount.bind(this);
        this.handleEscKeyPress = this.handleEscKeyPress.bind(this);
        this.handleSearchFormSubmit = this.handleSearchFormSubmit.bind(this);
        this.spyOnCartItemRemoveButton = this.spyOnCartItemRemoveButton.bind(this);
        this.spyOnCartQuantityUpdateSubmit = this.spyOnCartQuantityUpdateSubmit.bind(this);
        this.toggleSearchBar = this.toggleSearchBar.bind(this);
        this.getCategories = this.getCategoriesCall.bind(this);
        this.activateLogo = this._activateLogo.bind(this);
    }

    /**
     * @method componentDidMount - checks to see if the component has mounted to the DOM tree
     *                             prior to updating or executing functions contained within in.
     */
    componentDidMount() {
        /* Try/ catch/ execute block that returns the cart item total in the Navigation */
        this.getCategoriesCall();
        this.handleCartCount();
        document.addEventListener("keydown", this.handleEscKeyPress);  // Event data for the handleEscKeyPress method
    }

    componentDidUpdate() {
        /* When the navigation updates, check the status of the sidemenu */
        this.handleSideMenuChanges();
    }

    /**
     * @method getCategoriesCall
     */
    async getCategoriesCall() { // get categories from the course api
        try {
            const brandsCategories = await getBrandsCategories(1, 100);
            const returnedData = brandsCategories.data ? brandsCategories.data : {};
            this.setState({ categoriesData: returnedData });
            this.setState({ isLoading: false });
            /* Set active class on log for animation 150ms delay */
            setTimeout(this.activateLogo, 190);
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * Method that updates the totalCartItems state when the update buttons are pressed in the shopping cart. 
     * Uses addition of values for each cart item quantity field instead of making another API call. Once user
     * navigates to another page the totalCartItems state us updated via the API via the Shopping Cart App.
     * @param {event} event 
     */
    spyOnCartQuantityUpdateSubmit(event) {
        let updateCount = 0;
        if (event.target.classList.contains('cart-quantity-update-form')) {
            let formsArray = document.querySelectorAll('.cart-quantity-update-form');
            formsArray.forEach(item => {
                updateCount += parseInt(item.querySelector('.cart_qty_field.cart-item__modify__field').value);
            });
            this.setState({ totalCartItems: updateCount });
        }
    }

    /**
     * Method that updates the Navigation totalCartItems state using event delegation when the remove button is pressed on a cart item. Works in 
     * sync with the API call that is wired for the remove button in the Shopping Cart App.
     * @param {event} event 
     */
    spyOnCartItemRemoveButton(event) {
        if (event.target.classList.contains('cart-item__remove__button')) {
            let subtractionValue = parseInt(event.target.parentElement.nextElementSibling.querySelector('.cart_qty_field.cart-item__modify__field').value);
            let updateValue = (this.state.totalCartItems > 0) ? this.state.totalCartItems - subtractionValue : 0;
            this.setState({ totalCartItems: updateValue });
        }
    }

    /** Method that handles the updating of the totalCartItems state on page load using an API response */
    async handleCartCount() {
        try {
            axios.post('/cart/update').then(response => {
                this.setState({ totalCartItems: response.data.total });
                this.setState({ isLoading: false, pathName: window.location.pathname });
                if (this.state.pathName === '/checkout') {
                    document.addEventListener("submit", this.spyOnCartQuantityUpdateSubmit);
                    document.addEventListener("click", this.spyOnCartItemRemoveButton);
                }
            });
        } catch ({ response }) {
            status: (response.status) ? response.status : 500;
            message: (response.data && response.data.message) ? response.data.message : 'There was an error. Please try again.';
        }
    }

    /**
     * Method that sets the sidemenu and overlay to active states (sidemenu opened).
     * 
     * @param {event} event - click event on the sidebar toggle.
     */
    openSideBar(event, element) {
        this.setState({ sideMenu: 'active', overlay: 'active' });
    }

    /**
     * Method that sets the sidemenu and overlay to inactive states (sidemenu closed).
     * 
     * @param {event} - the onClick event from the sidebar toggle.
     */
    closeSideBar(event) {
        this.setState({ sideMenu: 'inactive', overlay: '' });
        setTimeout(() => (this.setState({ sideMenu: '' })), 500);
    }

    /**
     * Method that toggles the mobile search bar. State data is passed down to and up from the sideMenu component.
     * 
     * @param {event} - the onClick event from the sidebar toggle (open or close).
     */
    toggleSearchBar(event) {
        if (this.state.isMobileOpen !== 'active') {
            this.setState({ isMobileOpen: 'active' });
        } else {
            this.setState({ isMobileOpen: 'inactive' });
            setTimeout(() => (this.setState({ isMobileOpen: '' })), 500);
        }
    }

    /**
     * @method handleChange - This method handles and tracks the input for the search fields
     *                       in the navigation (mobile and desktop) and sets inputted values 
     *                       as the searchFieldValue state using event.target.value.
     * @param {event} - the onChange event which indicates character entries in the targetted search fields.
     */
    handleChange(event) {
        this.setState({ searchFieldValue: event.target.value });
    }

    /**
     * Method that cleans the URI and inserts '+' character wherever there is a space character in the user input
     * @param {string} fieldInput 
     * 
     * @return searchURI - returns a cleaned version of the search request
     */
    cleanURI(fieldInput) {
        let regexVal = /\s/gi; // For use as regular expression for replacing spaces with another character
        let newUri = fieldInput.replace(regexVal, '+'); // Replacing spaces with '+'
        let searchURI = decodeURIComponent('/search?q=' + newUri);
        return searchURI;
    }

    /**
     * Method for the search feature submissions.
     * 
     * @param {event} - the onSubmit event for search field forms.
     * 
     * @return cleanedURI - returns the final search request which combines the cleanedURI
     *                      with the window location. 
     */
    handleSearchFormSubmit(event) {
        event.preventDefault();
        let cleanedURI = this.cleanURI(this.state.searchFieldValue);
        window.location = cleanedURI;
        return cleanedURI;
    }

    /**
     * Handles the Esc keypress event that triggers the closing action of the sideMenu.
     * 
     * @param {event} - the onKeypress event on the Esc key.
     */
    handleEscKeyPress(event) {
        if (this.state.sideMenu === 'active') {
            var pressedKey = event.which || event.keycode;
            if (pressedKey === 27) {
                this.closeSideBar(event);
            }
        }
    }

    /**
     * Used for determining which links to select for the current page.
     * @param {object} linkData - data for the link coming from the json file which provides all link detail
     * @param {string} pathName - the pathname of the current page.
     */
    handleCurrentPageIndication(linkData, pathName) {
        let currentClass;
        if (linkData === pathName) {
            currentClass = 'main-nav__link current';
        } else {
            currentClass = 'main-nav__link';
        }
        return currentClass;
    }

    /** Sets up a mutation observer for menu activity that is independent of any event. */
    handleSideMenuChanges() {
        const sideMenuSubject = document.querySelector('.side-menu__block');
        const configureObserve = { attributes: true, childList: false, subtree: false };
        const myObserver = new MutationObserver(this.handleMenuOpenCloseActions);
        myObserver.observe(sideMenuSubject, configureObserve);
    }

    /** Gives focus to the side menu toggle button when there is a mutation (change) in the sidebar
     * and it loses the active state (i.e. the sidebar closes) */
    handleMenuOpenCloseActions(targetedElement) {
        Object.keys(targetedElement).forEach(item => {
            if (!targetedElement[item].target.classList.contains('active')) {
                $qs('.navigation-mobile__sidebar__toggle').focus();
            }
        });
    }

    _activateLogo() {
        this.setState({ activeLogo: true });
    }

    /**
     * @method render - renders/ returns the JSX Navigation component.
     */
    render() {
        const sideMenuLinkData = NavigationListData.sideNavigationList;
        const topNavigationLinkData = NavigationListData.topNavigationList;
        const cartItems = (this.state.totalCartItems === null || this.state.totalCartItems === 0 || this.state.totalCartItems > 1) ? 'items' : 'item';
        const logoStatus = (this.state.activeLogo) ? ' active' : '';

        return (
            <React.Fragment>
                <div id="scrollProgressBar"></div>
                <div id="headerContent" className={(this.state.isLoading) ? 'header-block nav--loading' : 'header-block nav--loaded'}>
                    <Spinner isLoading={this.state.isLoading} />
                    <SkipLinksBlock />
                    <nav className="navigation-block">

                        <h2 className="navigation-title h2-hide">Navigation</h2>
                        <div className="row--level1">
                            <div className="col-md-7 col-lg-7">
                                <div className="row--level2">
                                    <div className="navigation-mobile__sidebar__toggle__wrapper">
                                        <MDBBtn tabIndex="0" className="navigation-mobile__sidebar__toggle" onClick={(event) => this.openSideBar(event)} type="button" aria-label="Navigation Toggle" data-target="#sideMenu" aria-expanded={(this.state.sideMenu === 'active') ? 'true' : 'false'}> <i className="fas fa-bars" aria-hidden="true"></i></MDBBtn >
                                    </div>
                                    <div className="col-md-5 col-lg-5">
                                        <div className="navigation-logo__block">
                                            {(this.state.pathName === '/') ? <a className={'navigation-logo__link navigation-logo__link--desktop'} href="/" aria-label="Skye Logo - Large">
                                                <img className={'navigation-logo__desktop' + logoStatus} src="https://cdn.skyelearning.com/static/skye-logos/skye-learning-logo-rgb-horizontal-desktop.svg" alt="Skye Logo Desktop" />
                                            </a> :
                                                <a className="navigation-logo__link navigation-logo__link--desktop" href="/" aria-label="Home">
                                                    <img className={'navigation-logo__desktop' + logoStatus} src="https://cdn.skyelearning.com/static/skye-logos/skye-learning-logo-rgb-horizontal-desktop.svg" alt="Skye Logo Desktop" />
                                                </a>}

                                            {(this.state.pathName === '/') ? <a className="navigation-logo__link navigation-logo__link--tablet" href="/" aria-label="Skye Logo - Medium">
                                                <img className={'navigation-logo__tablet' + logoStatus} src="https://cdn.skyelearning.com/static/skye-logos/skye-learning-logo-rgb-shorthand-horizontal-tablet.svg" alt="Skye Logo Tablet" />
                                            </a> :
                                                <a className="navigation-logo__link navigation-logo__link--tablet" href="/" aria-label="Home">
                                                    <img className={'navigation-logo__tablet' + logoStatus} src="https://cdn.skyelearning.com/static/skye-logos/skye-learning-logo-rgb-shorthand-horizontal-tablet.svg" alt="Skye Logo Tablet" />
                                                </a>}

                                            {(this.state.pathName === '/') ? <a className="navigation-logo__link navigation-logo__link--mobile" href="/" aria-label="Skye Logo - Small">
                                                <img className={'navigation-logo__mobile' + logoStatus} src="https://cdn.skyelearning.com/static/skye-logos/skye-learning-logo-rgb-solo-mobile.svg" alt="Skye Mobile Logo" />
                                            </a> :
                                                <a className="navigation-logo__link navigation-logo__link--mobile" href="/" aria-label="Home">
                                                    <img className={'navigation-logo__mobile' + logoStatus} src="https://cdn.skyelearning.com/static/skye-logos/skye-learning-logo-rgb-solo-mobile.svg" alt="Skye Mobile Logo" />
                                                </a>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-lg-7">
                                        <div className="navigation-search__block">
                                            <form className="navigation-search__form" method="get" name="desk_search_form" onSubmit={(event) => this.handleSearchFormSubmit(event)}>
                                                <div className="navigation-search__group bmd-form-group">
                                                    <input id="navigationSearch" name="q" type="text" className="form-control navigation-search__form__control" placeholder="Search courses..." aria-label="Search courses" value={this.state.searchFieldValue} onChange={this.handleChange} />
                                                    <MDBBtn id="navigationSearchButton" tabIndex="0" type="button" className="btn btn-default navigation-search__button" aria-label="Search Categories" onClick={(event) => this.handleSearchFormSubmit(event)}>
                                                        <i className="navigation-search__button__icon fas fa-search"></i>
                                                    </MDBBtn>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-5 col-lg-5">
                                <div className="row--level2">
                                    <div className="col-md-12 col-lg-12">
                                        <div className="navigation-menu__block">
                                            <ul className="navigation-menu__list navigation-menu__list--desktop">
                                                <li className={('/' + this.state.pathName.split('/')[1] === '/categories') ? 'navigation-menu__item current category' : 'navigation-menu__item category'}>
                                                    <MDBDropdown className="btn-group dropright">
                                                        <MDBDropdownToggle id="navigationCategoryButton" type="button" className="btn dropdown-toggle navigation-category__button" data-toggle="dropdown" aria-haspopup={true} aria-expanded="false" tabIndex="0">
                                                            <div className="navigation-category__button__content__wrap">
                                                                <i className="fas fa-th navigation-category__button__icon" aria-hidden="true"></i>
                                                                <span className="navigation-category__button__label ubuntu--bold">Categories</span><i className="fa fa-caret-right icon-rotate" aria-hidden="true"></i>
                                                            </div>
                                                        </MDBDropdownToggle>
                                                        <MDBDropdownMenu className="navigation-category__list dropdown-menu scroll-styl1" role="menu">
                                                            {(typeof (this.state.categoriesData.data) !== 'undefined') ? this.state.categoriesData.data.map((item, index) =>
                                                                <React.Fragment key={index}>
                                                                    {(item.category_id && item.course_count > 0) ?
                                                                        <span className="navigation-category__list__item" role="menuitem">
                                                                            <a className={'navigation-category__list__link ' + this.handleCurrentPageIndication(makeMenuLink(item.category_id, item.name, '/categories/'), this.state.pathName)} href={makeMenuLink(item.category_id, item.name, '/categories/')}>{ReactHtmlParser(item.name)}</a>
                                                                        </span>
                                                                        : ''}

                                                                    {(item.brand_id && item.course_count > 0) ?
                                                                        <span className="navigation-category__list__item" role="menuitem">
                                                                            <a className={'navigation-category__list__link ' + this.handleCurrentPageIndication(makeMenuLink(item.brand_id, item.name, '/brands/'), this.state.pathName)} href={makeMenuLink(item.brand_id, item.name, '/brands/')}>{ReactHtmlParser(item.name)}</a>
                                                                        </span>
                                                                        : ''}
                                                                </React.Fragment>
                                                            ) : ''}
                                                        </MDBDropdownMenu>
                                                    </MDBDropdown>
                                                </li>
                                                {(topNavigationLinkData.length > 0) ? topNavigationLinkData.map((topNavData, index) =>
                                                    <li className={'navigation-menu__item' + ' ' + this.handleCurrentPageIndication(topNavData.href, this.state.pathName)} key={index}><a className={'navigation-menu__link btn'} href={topNavData.href} target={topNavData.target} rel={topNavData.rel ? topNavData.rel : ''}>{topNavData.link_text}</a></li>
                                                ) : ''}
                                                <li className={(this.state.pathName === '/checkout') ? 'navigation-menu__item cart current' : 'navigation-menu__item cart'}>
                                                    <a href="/checkout" id="cartBtnDesk" className={'navigation-menu__link cart btn'} aria-label={'Shopping Cart, You have ' +
                                                        (this.state.totalCartItems ? this.state.totalCartItems : 0) + ' ' + cartItems + ' in your cart.'} data-toggle="skye-popover-cart"
                                                        data-trigger="focus" data-placement="bottom" data-content="..." tabIndex="0">
                                                        <i className="fas fa-shopping-cart navigation-cart__icon__desktop" aria-hidden="true"></i>
                                                        <span className="navigation-menu__cart__label">Cart&nbsp;</span>
                                                        <span className="navigation-menu__cart__items__number cart-items-number">{this.state.totalCartItems ? this.state.totalCartItems : 0}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                            <ul className="navigation-menu__list navigation-menu__list--mobile">
                                                <li className="navigation-menu__item search">
                                                    <MDBBtn tabIndex="0" type="button" className="btn btn-default navigation-mobile__search__toggle" aria-label="Search Categories" onClick={(event) => this.toggleSearchBar(event)}>
                                                        <i className="navigation-mobile__search__button__icon fas fa-search"></i>
                                                    </MDBBtn>
                                                </li>
                                                <li className={(this.state.pathName === '/checkout') ? 'navigation-menu__item cart current' : 'navigation-menu__item cart'}>
                                                    <a href="/checkout" id="cartBtnMob" className={'navigation-menu__link cart btn'} aria-label={'Shopping Cart, You have ' +
                                                        (this.state.totalCartItems ? this.state.totalCartItems : 0) + ' ' + cartItems + ' in your cart.'} data-toggle="skye-popover-cart"
                                                        data-trigger="focus" data-placement="bottom" data-content="..." tabIndex="0">
                                                        <i className="fas fa-shopping-cart navigation-cart__icon__desktop" aria-hidden="true"></i>
                                                        <span className="navigation-menu__cart__label">Cart&nbsp;</span>
                                                        <span className="navigation-menu__cart__items__number cart-items-number">{this.state.totalCartItems ? this.state.totalCartItems : 0}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>

                    <div className={'navigation-mobile__search__block ' + this.state.isMobileOpen}>
                        <h2 className="navigation-mobile__search__title h2-hide">Secondary Navigation</h2>
                        <form className="navigation-mobile__search__form" name="mobile_nav_search_form" onSubmit={(event) => this.handleSearchFormSubmit(event)}>
                            <div className="navigation-mobile__search__group form-group bmd-form-group">
                                <label htmlFor="navigationMobileSearch" className="navigation-mobile__search__label bmd-label-floating">Search courses...</label>
                                <input type="text" name="q" className="navigation-mobile__search__field form-control" id="navigationMobileSearch" value={this.state.searchFieldValue} onChange={this.handleChange} aria-label="Search courses" />
                                <MDBBtn tabIndex="0" type="button" className="btn btn-default navigation-mobile__search__button drop" aria-label="Search Categories" onClick={(event) => this.handleSearchFormSubmit(event)}><i className="navigation-mobile__search__button__icon fas fa-search"></i></MDBBtn>
                                <span className="navigation-mobile__search__help bmd-help">Use this field to search our site.</span>
                            </div>
                        </form>
                    </div>
                </div>

                <SideNavigation
                    categoryList={this.state.categoriesData}
                    sidemenuLinks={sideMenuLinkData}
                    toggle={this.state.sideMenu}
                    overlay={this.state.overlay}
                    closeSideBar={this.closeSideBar}
                    pathName={this.state.pathName}
                ></SideNavigation>
                <div id="scrollTop"></div>
            </React.Fragment>
        );
    }
}

export default NavigationV2;
